const config = {
  innerId: 'clothes_rail_50_51_4_white_in',
  outerId: 'clothes_rail_50_51_4_white_out',
  fullId: 'clothes_rail_50_51_4_white',
  maxWidth: 820,
  minWidth: 460,
  mountOffset: 17,
};

export { config };
